import { SHOW_MODAL, HIDE_MODAL } from '../constants/actionTypes';
import * as modalType from '../constants/modalTypes';
import { selectedURLs } from './selectedURLs';
import { previewMedia } from './previewMedia';
import { upload } from './uploadCsv';
import { addSceneMediaData } from './addSceneMediaData';
import { addSkillDetailsData } from './addSkillDetailsData';
import { csvProcessingResults } from './csvProcessingResults';
import { bundleData } from './bundleData'
import { createActivityData } from './createActivityData';
import { createSkillData } from './createSkillData';
import { createSkillGroupData } from './createSkillGroupData';

import { combineReducers } from 'redux';

const modal = (state = {
    show: false,
    text: ''
}, action) => {
    switch (action.type) {
        case SHOW_MODAL:
            return {
                ...state,
                show: true,
                text: action.text
            };
        case HIDE_MODAL:
            return {
                ...state,
                show: false,
                text: ''
            };
        default:
            return state;
    }
};

const createFilteredModalReducer = (func, pred) => {
    return (state, action) => {
        const isInitializationCall = state === undefined;
        const shouldRunWrappedReducer = pred(action) || isInitializationCall;
        return shouldRunWrappedReducer ? func(state, action) : state;
    };
};

export default combineReducers({
    selectedURLs,
    previewMedia,
    addSceneMediaData,
    addSkillDetailsData,
    upload,
    csvProcessingResults,
    createActivityData,
    createSkillData,
    createSkillGroupData,
    bundleData,
    reprocessing:     createFilteredModalReducer(modal, action => action.dialog === modalType.REPROCESSING_MODAL),
    viewSource:       createFilteredModalReducer(modal, action => action.dialog === modalType.VIEW_SOURCE_MODAL),
    error:            createFilteredModalReducer(modal, action => action.dialog === modalType.ERROR_MODAL),
    addSceneMedia:    createFilteredModalReducer(modal, action => action.dialog === modalType.ADD_SCENE_MEDIA_MODAL),
    addSkillDetails:  createFilteredModalReducer(modal, action => action.dialog === modalType.ADD_SKILL_DETAILS_MODAL),
    downloadCsv:      createFilteredModalReducer(modal, action => action.dialog === modalType.DOWNLOAD_CSV_MODAL),
    uploadCsv:        createFilteredModalReducer(modal, action => action.dialog === modalType.UPLOAD_CSV_MODAL),
    csvResults:       createFilteredModalReducer(modal, action => action.dialog === modalType.CSV_RESULTS_MODAL),
    buildBundles:     createFilteredModalReducer(modal, action => action.dialog === modalType.BUILD_BUNDLES_MODAL),
    createActivity:   createFilteredModalReducer(modal, action => action.dialog === modalType.CREATE_ACTIVITY_MODAL),
    createSkill:      createFilteredModalReducer(modal, action => action.dialog === modalType.CREATE_SKILL_MODAL),
    createSkillGroup: createFilteredModalReducer(modal, action => action.dialog === modalType.CREATE_SKILL_GROUP_MODAL) 
    
});



// WEBPACK FOOTER //
// ./src/reducers/ui.js